import networkService from '../Network/NetworkManager';
import APPURL from '../Constants/URLConstants';
import {uuid} from 'uuidv4';

export const switchTenant = async tenant_id => {
  const responseJson = await networkService.networkCall(
    `skua/users/switch_tenant`,
    'post',
    JSON.stringify({uuid: uuid(), tenant_id: tenant_id}),
    '',
    '',
  );
  return responseJson.data.user;
};
